/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface LineItemBase
 */
export interface LineItemBaseOptional {
  /**
   * Base cost of a single unit of this line item (From catalog or amount specified, if allowed)
   * @type {number}
   * @memberof LineItemBase
   */
  amountBaseCents?: number;
  /**
   * Specified cost of a single unit of this line item(For catalog items that support variable pricing)
   * @type {number}
   * @memberof LineItemBase
   */
  amountSpecifiedCents?: number;
  /**
   * Amount of money successfully paid
   * @type {number}
   * @memberof LineItemBase
   */
  amountPaidCents?: number;
  /**
   * Total value (in cents) of a single unit times quantity (excluding discounts and taxes)
   * @type {number}
   * @memberof LineItemBase
   */
  amountSubtotalCents?: number;
  /**
   * Total value (in cents) of a single unit times quantity (including discounts and taxes)
   * @type {number}
   * @memberof LineItemBase
   */
  amountTotalCents?: number;
  /**
   *
   * @type {boolean}
   * @memberof LineItemBase
   */
  autoAdded?: boolean;
  /**
   *
   * @type {string}
   * @memberof LineItemBase
   */
  squareLineItemUid?: string;
}

export interface LineItemBase extends LineItemBaseOptional {
  /**
   * Base cost of a single unit of this line item (From catalog or amount specified, if allowed)
   * @type {number}
   * @memberof LineItemBase
   */
  amountBaseCents: number;
  /**
   * Specified cost of a single unit of this line item(For catalog items that support variable pricing)
   * @type {number}
   * @memberof LineItemBase
   */
  amountSpecifiedCents?: number;
  /**
   * Amount of money successfully paid
   * @type {number}
   * @memberof LineItemBase
   */
  amountPaidCents?: number;
  /**
   * Total value (in cents) of a single unit times quantity (excluding discounts and taxes)
   * @type {number}
   * @memberof LineItemBase
   */
  amountSubtotalCents?: number;
  /**
   * Total value (in cents) of a single unit times quantity (including discounts and taxes)
   * @type {number}
   * @memberof LineItemBase
   */
  amountTotalCents?: number;
  /**
   *
   * @type {boolean}
   * @memberof LineItemBase
   */
  autoAdded?: boolean;
  /**
   *
   * @type {string}
   * @memberof LineItemBase
   */
  squareLineItemUid?: string;
}

export interface LineItemBaseTrackedI {
  /**
   * Base cost of a single unit of this line item (From catalog or amount specified, if allowed)
   * @type {number}
   * @memberof LineItemBase
   */
  amountBaseCents?: number;
  amountBaseCentsIsSet: boolean;
  /**
   * Specified cost of a single unit of this line item(For catalog items that support variable pricing)
   * @type {number}
   * @memberof LineItemBase
   */
  amountSpecifiedCents?: number;
  amountSpecifiedCentsIsSet: boolean;
  /**
   * Amount of money successfully paid
   * @type {number}
   * @memberof LineItemBase
   */
  amountPaidCents?: number;
  amountPaidCentsIsSet: boolean;
  /**
   * Total value (in cents) of a single unit times quantity (excluding discounts and taxes)
   * @type {number}
   * @memberof LineItemBase
   */
  amountSubtotalCents?: number;
  amountSubtotalCentsIsSet: boolean;
  /**
   * Total value (in cents) of a single unit times quantity (including discounts and taxes)
   * @type {number}
   * @memberof LineItemBase
   */
  amountTotalCents?: number;
  amountTotalCentsIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof LineItemBase
   */
  autoAdded?: boolean;
  autoAddedIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof LineItemBase
   */
  squareLineItemUid?: string;
  squareLineItemUidIsSet: boolean;
}

transformDatesMap.set("LineItemBase", function (model: LineItemBase) {});

export type LineItemBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  amountBaseCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountSpecifiedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountPaidCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountSubtotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  amountTotalCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  autoAdded: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  squareLineItemUid: PropertyMeta<MetaTypeBase<string>>;
}>;

export var LineItemBaseMeta: LineItemBaseMetaI = {} as LineItemBaseMetaI;
LineItemBaseMeta = typeMeta("LineItemBase", {
  amountBaseCents: propertyMeta(
    "amountBaseCents",
    false,
    true,
    false,
    MetaTypesBase.number,
  ),
  amountSpecifiedCents: propertyMeta(
    "amountSpecifiedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountPaidCents: propertyMeta(
    "amountPaidCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountSubtotalCents: propertyMeta(
    "amountSubtotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  amountTotalCents: propertyMeta(
    "amountTotalCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  autoAdded: propertyMeta(
    "autoAdded",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  squareLineItemUid: propertyMeta(
    "squareLineItemUid",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
});

const metaI = LineItemBaseMeta;

registerMeta(() => {});

export class LineItemBaseTracked implements LineItemBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  amountBaseCents__I?: number = undefined;
  amountBaseCentsIsSet: boolean = false;
  set amountBaseCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountBaseCents__I = v;
      this.amountBaseCentsIsSet = true;
    } else {
      this.amountBaseCents__I = v || undefined;
      this.amountBaseCentsIsSet = true;
    }
    this.changeTracker = true;
  }
  get amountBaseCents() {
    return this.amountBaseCents__I;
  }
  amountSpecifiedCents__I?: number = undefined;
  amountSpecifiedCentsIsSet: boolean = false;
  set amountSpecifiedCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountSpecifiedCents__I = v;
      this.amountSpecifiedCentsIsSet = true;
    } else {
      this.amountSpecifiedCents__I = v || undefined;
      this.amountSpecifiedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountSpecifiedCents() {
    return this.amountSpecifiedCents__I;
  }
  amountPaidCents__I?: number = undefined;
  amountPaidCentsIsSet: boolean = false;
  set amountPaidCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountPaidCents__I = v;
      this.amountPaidCentsIsSet = true;
    } else {
      this.amountPaidCents__I = v || undefined;
      this.amountPaidCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountPaidCents() {
    return this.amountPaidCents__I;
  }
  amountSubtotalCents__I?: number = undefined;
  amountSubtotalCentsIsSet: boolean = false;
  set amountSubtotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountSubtotalCents__I = v;
      this.amountSubtotalCentsIsSet = true;
    } else {
      this.amountSubtotalCents__I = v || undefined;
      this.amountSubtotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountSubtotalCents() {
    return this.amountSubtotalCents__I;
  }
  amountTotalCents__I?: number = undefined;
  amountTotalCentsIsSet: boolean = false;
  set amountTotalCents(v: undefined | number) {
    if (v !== undefined) {
      this.amountTotalCents__I = v;
      this.amountTotalCentsIsSet = true;
    } else {
      this.amountTotalCents__I = v || undefined;
      this.amountTotalCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get amountTotalCents() {
    return this.amountTotalCents__I;
  }
  autoAdded__I?: boolean = undefined;
  autoAddedIsSet: boolean = false;
  set autoAdded(v: undefined | boolean) {
    if (v !== undefined) {
      this.autoAdded__I = v;
      this.autoAddedIsSet = true;
    } else {
      this.autoAdded__I = v || undefined;
      this.autoAddedIsSet = false;
    }
    this.changeTracker = true;
  }
  get autoAdded() {
    return this.autoAdded__I;
  }
  squareLineItemUid__I?: string = undefined;
  squareLineItemUidIsSet: boolean = false;
  set squareLineItemUid(v: undefined | string) {
    if (v !== undefined) {
      this.squareLineItemUid__I = v;
      this.squareLineItemUidIsSet = true;
    } else {
      this.squareLineItemUid__I = v || undefined;
      this.squareLineItemUidIsSet = false;
    }
    this.changeTracker = true;
  }
  get squareLineItemUid() {
    return this.squareLineItemUid__I;
  }
  constructor(config?: LineItemBaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: LineItemBaseOptional,
    options?: AssignOptions,
  ): LineItemBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.amountBaseCents &&
      this.amountBaseCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountBaseCents = config.amountBaseCents;
      if (optionsRequired.unassign) this.amountBaseCentsIsSet = false;
      else this.amountBaseCentsIsSet = true;
    }
    if (
      config.amountSpecifiedCents &&
      this.amountSpecifiedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountSpecifiedCents = config.amountSpecifiedCents;
      if (optionsRequired.unassign) this.amountSpecifiedCentsIsSet = false;
      else this.amountSpecifiedCentsIsSet = true;
    }
    if (
      config.amountPaidCents &&
      this.amountPaidCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountPaidCents = config.amountPaidCents;
      if (optionsRequired.unassign) this.amountPaidCentsIsSet = false;
      else this.amountPaidCentsIsSet = true;
    }
    if (
      config.amountSubtotalCents &&
      this.amountSubtotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountSubtotalCents = config.amountSubtotalCents;
      if (optionsRequired.unassign) this.amountSubtotalCentsIsSet = false;
      else this.amountSubtotalCentsIsSet = true;
    }
    if (
      config.amountTotalCents &&
      this.amountTotalCentsApplyFilter(optionsRequired.filter)
    ) {
      this.amountTotalCents = config.amountTotalCents;
      if (optionsRequired.unassign) this.amountTotalCentsIsSet = false;
      else this.amountTotalCentsIsSet = true;
    }
    if (config.autoAdded && this.autoAddedApplyFilter(optionsRequired.filter)) {
      this.autoAdded = config.autoAdded;
      if (optionsRequired.unassign) this.autoAddedIsSet = false;
      else this.autoAddedIsSet = true;
    }
    if (
      config.squareLineItemUid &&
      this.squareLineItemUidApplyFilter(optionsRequired.filter)
    ) {
      this.squareLineItemUid = config.squareLineItemUid;
      if (optionsRequired.unassign) this.squareLineItemUidIsSet = false;
      else this.squareLineItemUidIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): LineItemBaseTrackedI {
    const cloned = {} as LineItemBaseTrackedI;
    if (
      this.amountBaseCentsIsSetDeep() &&
      this.amountBaseCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountBaseCentsIsSet = true;
      cloned.amountBaseCents = this.amountBaseCents;
    } else {
      //cloned.amountBaseCentsIsSet = false
    }
    if (
      this.amountSpecifiedCentsIsSetDeep() &&
      this.amountSpecifiedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountSpecifiedCentsIsSet = true;
      cloned.amountSpecifiedCents = this.amountSpecifiedCents;
    } else {
      //cloned.amountSpecifiedCentsIsSet = false
    }
    if (
      this.amountPaidCentsIsSetDeep() &&
      this.amountPaidCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountPaidCentsIsSet = true;
      cloned.amountPaidCents = this.amountPaidCents;
    } else {
      //cloned.amountPaidCentsIsSet = false
    }
    if (
      this.amountSubtotalCentsIsSetDeep() &&
      this.amountSubtotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountSubtotalCentsIsSet = true;
      cloned.amountSubtotalCents = this.amountSubtotalCents;
    } else {
      //cloned.amountSubtotalCentsIsSet = false
    }
    if (
      this.amountTotalCentsIsSetDeep() &&
      this.amountTotalCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.amountTotalCentsIsSet = true;
      cloned.amountTotalCents = this.amountTotalCents;
    } else {
      //cloned.amountTotalCentsIsSet = false
    }
    if (
      this.autoAddedIsSetDeep() &&
      this.autoAddedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.autoAddedIsSet = true;
      cloned.autoAdded = this.autoAdded;
    } else {
      //cloned.autoAddedIsSet = false
    }
    if (
      this.squareLineItemUidIsSetDeep() &&
      this.squareLineItemUidApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.squareLineItemUidIsSet = true;
      cloned.squareLineItemUid = this.squareLineItemUid;
    } else {
      //cloned.squareLineItemUidIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): LineItemBaseTrackedI {
    if (!this.amountBaseCentsApplyFilter(filter))
      this.amountBaseCentsIsSet = false;

    if (!this.amountSpecifiedCentsApplyFilter(filter))
      this.amountSpecifiedCentsIsSet = false;

    if (!this.amountPaidCentsApplyFilter(filter))
      this.amountPaidCentsIsSet = false;

    if (!this.amountSubtotalCentsApplyFilter(filter))
      this.amountSubtotalCentsIsSet = false;

    if (!this.amountTotalCentsApplyFilter(filter))
      this.amountTotalCentsIsSet = false;

    if (!this.autoAddedApplyFilter(filter)) this.autoAddedIsSet = false;

    if (!this.squareLineItemUidApplyFilter(filter))
      this.squareLineItemUidIsSet = false;

    return this;
  }
  amountBaseCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemBaseMeta.amountBaseCents,
      LineItemBaseMeta,
      this.amountBaseCents,
      this,
    );
  }
  amountBaseCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountBaseCentsIsSet && this.amountBaseCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountSpecifiedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemBaseMeta.amountSpecifiedCents,
      LineItemBaseMeta,
      this.amountSpecifiedCents,
      this,
    );
  }
  amountSpecifiedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountSpecifiedCentsIsSet &&
      this.amountSpecifiedCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountPaidCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemBaseMeta.amountPaidCents,
      LineItemBaseMeta,
      this.amountPaidCents,
      this,
    );
  }
  amountPaidCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountPaidCentsIsSet && this.amountPaidCentsApplyFilter(filter))
      return true;

    return false;
  }
  amountSubtotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemBaseMeta.amountSubtotalCents,
      LineItemBaseMeta,
      this.amountSubtotalCents,
      this,
    );
  }
  amountSubtotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.amountSubtotalCentsIsSet &&
      this.amountSubtotalCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  amountTotalCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemBaseMeta.amountTotalCents,
      LineItemBaseMeta,
      this.amountTotalCents,
      this,
    );
  }
  amountTotalCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.amountTotalCentsIsSet && this.amountTotalCentsApplyFilter(filter))
      return true;

    return false;
  }
  autoAddedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemBaseMeta.autoAdded,
      LineItemBaseMeta,
      this.autoAdded,
      this,
    );
  }
  autoAddedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.autoAddedIsSet && this.autoAddedApplyFilter(filter)) return true;

    return false;
  }
  squareLineItemUidApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      LineItemBaseMeta.squareLineItemUid,
      LineItemBaseMeta,
      this.squareLineItemUid,
      this,
    );
  }
  squareLineItemUidIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.squareLineItemUidIsSet &&
      this.squareLineItemUidApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.amountBaseCentsIsSetDeep(filter)) return true;
    if (this.amountSpecifiedCentsIsSetDeep(filter)) return true;
    if (this.amountPaidCentsIsSetDeep(filter)) return true;
    if (this.amountSubtotalCentsIsSetDeep(filter)) return true;
    if (this.amountTotalCentsIsSetDeep(filter)) return true;
    if (this.autoAddedIsSetDeep(filter)) return true;
    if (this.squareLineItemUidIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
